export default class SalaryTypeActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_SALARYTYPE='GET_HELPER_SALARYTYPE';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: SalaryTypeActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: SalaryTypeActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: SalaryTypeActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: SalaryTypeActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: SalaryTypeActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: SalaryTypeActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: SalaryTypeActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: SalaryTypeActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: SalaryTypeActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: SalaryTypeActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: SalaryTypeActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: SalaryTypeActions.GET_HELPER_SALARYTYPE,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: SalaryTypeActions.ERROR_SERVER,
      payload: error
    };
  }
}